import { lang, _lang } from '@umu/ukit-lang';
import { IColumn, IOption } from './radarTypes';
import { polarToX, polarToY } from './radarUtil';
// @ts-ignore
import earSmall from './images/wheat_ears_small.png';
// @ts-ignore
import earTop from './images/wheat_ears_top.png';
// @ts-ignore
import earBottomLeft from './images/wheat_ear_left.png';
// @ts-ignore
import earBottomRight from './images/wheat_ear_right.png';

// import earBottomL from './images/wheat_ears_bottom_l.png';

/**
 * 计算水平、垂直方向的偏移。不同维度下不同位置的偏移不同，根据视觉效果手动设置。
 */
const captionOffset = (i: number, length: number) => {
    i = i % length;
    let verticalOffset = 0;
    let horizonOffset = 0;

    switch (length) {
        case 3:
            if (i === 0) {
                verticalOffset = 1;
            } else {
                verticalOffset = -2;
            }
            if (i === 1) {
                horizonOffset = 8;
            } else if (i === 2) {
                horizonOffset = -8;
            }
            break;

        case 4:
            if (i === 0) {
                verticalOffset = 1;
            } else if (i === 2) {
                verticalOffset = 5;
            } else {
                verticalOffset = 3;
            }
            if (i === 1) {
                horizonOffset = 5;
            } else if (i === 3) {
                horizonOffset = -5;
            }
            break;

        case 5:
            if (i === 0) {
                verticalOffset = 2;
            } else if (i === 2 || i === 3) {
                verticalOffset = 0;
            } else if (i === 1 || i === 4) {
                verticalOffset = 8;
            }
            if (i === 1) {
                horizonOffset = 6;
            } else if (i === 2) {
                horizonOffset = 12;
            } else if (i === 3) {
                horizonOffset = -12;
            } else if (i === 4) {
                horizonOffset = -6;
            }
            break;

        case 6:
            if (i === 3) {
                verticalOffset = 4;
            } else if (i === 1 || i === 5) {
                verticalOffset = 8;
            } else if (i === 2 || i === 4) {
                verticalOffset = -2;
            } else {
                verticalOffset = 2;
            }
            if (i === 1 || i === 2) {
                horizonOffset = 8;
            } else if (i === 4 || i === 5) {
                horizonOffset = -8;
            }
            break;
    }

    return [horizonOffset, verticalOffset];
};

export const caption = (opt: IOption) => (col: IColumn, i: number, all: IColumn[]) => {
    const rangeMax = opt.rangeMax || 5;
    const DISPLAY_WHEAT_EARS_THRESHOLD = 0.8 * rangeMax; // 大于该值则展示花穗
    const DISPLAY_BOTTOM_THRESHOLD = 0.9 * rangeMax; // 大于该值则展示花穗和底座

    const offset = captionOffset(i, all.length);
    const x = polarToX(col.angle as number, (opt.size / 2) * 1) + offset[0];
    const y = polarToY(col.angle as number, (opt.size / 2) * 1) + offset[1];

    let labelTxt = Number(col.value) <= 5 ? (+col.value).toFixed(1) : Number((+col.value).toFixed(1));
    let labelCls = '';
    if (col.value === 0) {
        labelTxt = lang('一团迷雾');
        labelCls = 'fog';
    }
    if (
        opt.aiVoiceCheckSwitch !== undefined &&
        opt.aiVoiceCheckSwitch === 0 &&
        (col.key === 'speed' || col.key === 'smooth')
    ) {
        col.value = 0;
        labelTxt = lang('未开启');
        labelCls = 'fog';
    }

    let titleSize = 12;
    let valueSize = 24;
    let widthRatio=1;
    if (_lang('JP')) {
        valueSize = 16.8;
    }
    if (_lang('EN')) {
        widthRatio=0.5
        titleSize = 7.2;
        valueSize = 16.8;
    }
    if (_lang('ES') || _lang('FR')) {
        widthRatio=0.5
        titleSize = 7.2;
        valueSize = 16.8;
    }
    if (col.value === 0) {
        titleSize = 12;
    }

    const labelChildren:string[] = [];

    // 分值
    let valueOffsetY = -16;
    if (col.value === 0) {
        valueOffsetY += 2;
    }
    labelChildren.push(`
    <text
        font-size="${valueSize}"
        dy="${valueOffsetY}"
        alignment-baseline="middle"
        text-anchor="middle"
        class="caption-value"
        dx="1"
        >${labelTxt}</text>
    `);

    if (Number(col.value) >= DISPLAY_BOTTOM_THRESHOLD) {
        // 大于 DISPLAY_BOTTOM_THRESHOLD 显示花穗和底座
        let wheatEarsWidth = 72;
        if (_lang('EN')) {
            wheatEarsWidth = 80;
        }
        const wheatEarsXOffset = wheatEarsWidth / 2;
        labelChildren.push(`
        <image
            x="${-wheatEarsXOffset}"
            y="-40"
            width="${wheatEarsWidth}"
            height="44"
            xlink:href="${earTop}"
        ></image>
        `);
        // 维度名称
        const _width=titleSize * Number((col.caption as string).length) * widthRatio
        const width=_width>48 ? _width : 48;

        const imageHeight=22;
        const imageOriginWidth=44;
        const imageWidth=imageHeight*imageOriginWidth/44;
        const imageOffsetY=-4;

        const computeLeftEarOffsetX=-width/2-imageWidth;
        const leftEarOffsetX=Math.abs(computeLeftEarOffsetX)>46 ? computeLeftEarOffsetX : -46;

        const computeRightEarOffsetX=width/2;
        const rightEarOffsetX=Math.abs(computeRightEarOffsetX)>22 ? computeRightEarOffsetX : 22;
        labelChildren.push(`
        <image
            x="${leftEarOffsetX}"
            y="${imageOffsetY}"
            height="${imageHeight}"
            xlink:href="${earBottomLeft}"
        ></image>
        `);
        labelChildren.push(`
        <image
            x="${rightEarOffsetX}"
            y="${imageOffsetY}"
            height="${imageHeight}"
            xlink:href="${earBottomRight}"
        ></image>
        `);

        labelChildren.push(`
            <rect x="${-width/2 +2}" y="${imageOffsetY}" width="${width}" height="20" fill="#FF860C" />
        `)
        labelChildren.push(`
        <text
            dy="${6}"
            alignment-baseline="middle",
            class="caption-title"
            text-anchor="middle"
            font-size="${titleSize}"
            font-family="sans-serif"
            fill="#FFFFFF"
            >${col.caption}</text>
        `);
    } else {
        // 大于 DISPLAY_WHEAT_EARS_THRESHOLD 则显示花穗
        if (Number(col.value) >= DISPLAY_WHEAT_EARS_THRESHOLD) {
            let wheatEarsWidth = 61;
            if (_lang('EN')) {
                wheatEarsWidth = 68;
            }

            const wheatEarsOffset = wheatEarsWidth / 2;

            labelChildren.push(`
            <image
                x="${-wheatEarsOffset}"
                y="-32.4"
                width="${wheatEarsWidth}"
                height="28"
                xlink:href="${earSmall}"
            ></image>
            `);
        }

        // 维度名称
        let titleOffsetY = ((opt.captionProps(col).fontSize as number) || 2) * 2;
        if (col.value === 0) {
            titleOffsetY -= 2;
        }
        labelChildren.push(`
        <text
            dy="${titleOffsetY}"
            alignment-baseline="middle",
            class="caption-title"
            text-anchor="middle"
            font-size="${titleSize}"
            font-family="sans-serif"
            fill="#666666"
            >${col.caption}</text>
        `);
    }

    return `
    <g
    class="caption-group ${labelCls}"
    transform="translate(${x},${y}) scale(0.4)"
    >
        ${labelChildren.join('')}
    </g>
    `;
};
